/** Wire event names for asynchronous guide bulk deletion. */
export const GuideBulkDeleteProgressTypes = {
  GUIDE_BULK_DELETE_PROGRESS: '[Guide Administration] Bulk Delete Progress',
} as const;

/** Terminal status emitted for one guide in a bulk-delete job. */
export type GuideBulkDeleteProgressStatus = 'succeeded' | 'failed';

/** Progress payload for one guide in an asynchronous bulk-delete job. */
export interface GuideBulkDeleteProgressEventPayload {
  jobId: string;
  userId: string;
  status: GuideBulkDeleteProgressStatus;
  message?: string;
}

/** Sends one guide's terminal bulk-delete result to the acting administrator. */
export class GuideBulkDeleteProgressEvent {
  readonly type =
    GuideBulkDeleteProgressTypes.GUIDE_BULK_DELETE_PROGRESS;

  /**
   * Creates a bulk-delete progress socket event.
   * @param payload - Job and guide result sent to the portal.
   */
  constructor(public payload: GuideBulkDeleteProgressEventPayload) {}
}
